<ion-content class="modal-outher-container">
  <ion-grid class="modal-inner-container modal-inner-container--small">
    <ion-row>
      <ion-col>
        <app-modal-header
          [header]="translate.instant(modalSettings.header)"
          (close)="back()"
        >
        </app-modal-header>
        <ion-grid>
          <ion-row>
            <ion-col>
              <app-select-dropdown
                [value]="modalSettings.currentValue"
                [data]="modalSettings.data"
                [placeholder]="
                  modalSettings.placeholder?.length
                    ? translate.instant(modalSettings.placeholder)
                    : translate.instant(modalSettings.header)
                "
                (changeValueEvent)="sortChange($event)"
              >
              </app-select-dropdown>

              <ion-label
                *ngIf="modalSettings.valueRequied && outputData?.length == 0"
                color="danger"
                class="font-size__16"
              >
                {{ "SPACE.REQUIRED_VALIDATION" | translate }}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col
              class="display-flex {{clearButton ? 'ion-justify-content-between' : 'ion-justify-content-end'}}"
            >
              <ion-button
                *ngIf="clearButton"
                size="medium"
                fill="outline"
                (click)="clear()"
              >
                {{ 'CLEAR' | translate }}
              </ion-button>
              <ion-button
              size="medium"
              (click)="save()"
              [disabled]="
                modalSettings.valueRequied && outputData?.length == 0
              "
            >
              {{
                modalSettings.buttonText
                  ? (modalSettings.buttonText | translate)
                  : ("SAVE" | translate)
              }}
            </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
